export const blockIconsMapsCelebration = (
	<span className='material-symbols-outlined'>celebration</span>
);
